/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#footer[_ngcontent-%COMP%]{position:absolute;right:0;bottom:0;left:0;padding:1rem;background-color:#efefef;text-align:center}\n/*# sourceMappingURL=app.component.css.map*/"];
export { styles as styles };
